import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/slices/auth";
import planReducer from "../store/slices/plan";
import userReducer from "../store/slices/user"

const rootReducer = combineReducers({
  auth: authReducer,
  plan:planReducer,
  user:userReducer,

});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
export default store;
